module.exports = __webpack_public_path__ + "static/media/attendanceActiveIcon.c94cede9.svg";